import { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { portfolioData as fallbackData } from '../components/Mars/data';

const CACHE_KEY = 'mars_portfolio_data_v6';
const CACHE_DURATION = 1000;

export const usePortfolioData = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);

                // 1. Check LocalStorage Cache
                const cached = localStorage.getItem(CACHE_KEY);
                if (cached) {
                    const { timestamp, payload } = JSON.parse(cached);
                    // Check validity
                    if (Date.now() - timestamp < CACHE_DURATION) {
                        console.log("Hook: Cache HIT");
                        setData(payload);
                        setLoading(false);
                        return;
                    }
                }

                console.log("Hook: Fetching fresh data from Firestore...");

                // Fetch Single Monolithic Document
                const docRef = doc(db, "cms", "portfolio_v1");
                const docSnap = await getDoc(docRef);

                let fetchedData;
                if (docSnap.exists()) {
                    console.log("Hook: Firestore Document FOUND");
                    fetchedData = docSnap.data();
                } else {
                    console.warn("Hook: Doc not found. Falling back to static data.");
                    fetchedData = fallbackData;
                }

                setData(fetchedData);
                localStorage.setItem(CACHE_KEY, JSON.stringify({
                    timestamp: Date.now(),
                    payload: fetchedData
                }));

            } catch (err) {
                console.error("Hook: Error fetching data:", err);
                setError(err);
                setData(fallbackData);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    return { data, loading, error };
};
